import React from 'react';
import GridContainer from "@/components/common/GridContainer";
import {getCssSizeValue, getPaddingsClassFromData} from "@/utils/utils";

import PressMediaFeed from "@/components/Press/MediaFeed";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import HeaderDescription from "@/components/common/Header&Description";

const Container = styled(GridContainer)`
    row-gap: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        row-gap: ${getCssSizeValue(70, BREAKPOINTS.DESKTOP)};
	}
`
const Press = ({ data }) => {
	const paddings = getPaddingsClassFromData(data)
	const headerDescription = data?.headerDescription || {}
	const initialActions = data?.initialActions || {}
	const allActionsCount = data?.initialActionsMeta?.count || 0
	return (
		<Container className={`${paddings}`}>
			<HeaderDescription data={headerDescription} className={"col-mobile-8 col-desktop-6 border-top"} />
			<PressMediaFeed data={initialActions} count={allActionsCount} className={"no-margin col-mobile-8 col-desktop-16"}/>
		</Container>
	);
};

export default Press;
